import { useMutation } from '@tanstack/react-query';
import { useAuth } from '@clerk/clerk-react';

export function useDownloadSubscriptionInvoiceMutation() {
  const { getToken } = useAuth();

  return useMutation({
    mutationFn: async ({ organizationId, transactionId }: { organizationId: string; transactionId: string }) => {
      const token = await getToken();
      if (!token) {
        throw new Error('Not authenticated');
      }
      const url = `${import.meta.env.VITE_API_URL}/transactions/organization/${organizationId}/transaction/${transactionId}/invoice`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 503) {
        throw new Error('INVOICE_SUPPORT_PENDING');
      }

      if (!response.ok) {
        throw new Error('Failed to download invoice');
      }

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);

      const newTab = window.open(downloadUrl, '_blank', 'noopener,noreferrer');
      if (newTab) {
        newTab.addEventListener('load', () => window.URL.revokeObjectURL(downloadUrl));
      } else {
        window.URL.revokeObjectURL(downloadUrl);
      }
    },
  });
}
